import type { UserDeviceActivityType } from '../types/fingerPrintType';
import { useUserMeQuery } from '@/queries/user/user.queries';
import { getFingerprintAgent } from '../index';

interface GetFingerprintRequestIdNoCacheProps {
  activityType: UserDeviceActivityType;
}

export const useFingerprintRequestIdNoCache = ({ activityType }: GetFingerprintRequestIdNoCacheProps) => {
  const { data: user } = useUserMeQuery();
  const userId = user?.id;

  const getFingerprintRequestIdNoCache = async (): Promise<string> => {
    const promise = getFingerprintAgent();
    if (!promise) {
      return '';
    }

    const agent = await promise;
    const data = await agent.get({
      linkedId: userId,
      tag: { type: activityType },
    });

    return data?.requestId ?? '';
  };

  return { getFingerprintRequestIdNoCache };
};
